import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTreeModule, MatTreeNestedDataSource } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-tree',
  standalone: true,
  imports: [
    MatTreeModule,
    MatIconModule,
    MatButtonModule,
    CommonModule
  ],
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.scss']
})
export class TreeComponent implements OnChanges {

  @Input() title: string;
  @Input() treeData: node[];
  @Input() sortedKeys: { key: string, separator: string }[];

  treeControl = new NestedTreeControl<node>(node => node.children);
  dataSource = new MatTreeNestedDataSource<node>();

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['treeData']) {
      this.dataSource.data = this.treeData;
    }
  }

  hasChild = (_: number, node: node) => !!node.children && node.children.length > 0;

}

export interface node {
  name: string;
  [key: string]: any;
  children?: node[];
}